<div class="confirm-modal">
    <div class="confirm-modal__header">
        <h3>{{ title }}</h3>
        <button type="button" class="confirm-modal__close" (click)="activeModal.dismiss()"
            [attr.aria-label]="'admin_action_close' | translate">&times;</button>
    </div>

    <div class="confirm-modal__body">
        @if (message) {
            <p class="msg">{{ message }}</p>
        }

        @if (subject) {
            <p class="subject">{{ subject }}</p>
        }

        @if (consequence) {
            <p class="warn">{{ consequence }}</p>
        }
    </div>

    <div class="confirm-modal__actions">
        <button type="button" class="btn-cancel" (click)="activeModal.dismiss()">{{ cancelLabel }}</button>
        <button ngbAutofocus type="button" class="btn-confirm" (click)="activeModal.close(true)">
            {{ confirmLabel }}
        </button>
    </div>
</div>
